import cx from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TextInput(_ref) {
  let {
    label,
    id,
    error,
    matchPattern,
    description,
    value,
    onChange = () => {},
    inputSuffix,
    className,
    mktSelector,
    qaSelector,
    isValid,
    bare = false,
    ...props
  } = _ref;
  let input;
  function handleChange(event) {
    if (matchPattern && !event.target.value.match(matchPattern)) {
      return;
    }
    onChange(event.target.value);
  }
  if (props.isTextArea === true) {
    input = /*#__PURE__*/_jsx("textarea", {
      className: cx('form-control', className, {
        'is-invalid': isValid !== false
      }),
      id: id,
      value: value,
      onChange: handleChange,
      ...props
    });
  } else {
    input = /*#__PURE__*/_jsx(Input, {
      type: props.type,
      className: className,
      error: error,
      id: id,
      value: value,
      onChange: handleChange,
      inputSuffix: inputSuffix,
      isValid: isValid !== false,
      "data-mkt-selector": mktSelector,
      "data-qa-selector": qaSelector || mktSelector,
      ...props
    });
  }
  if (bare === true) {
    return input;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "form-group",
    children: [label && /*#__PURE__*/_jsx("label", {
      className: "font-weight-bold",
      htmlFor: id,
      children: label
    }), input, description && /*#__PURE__*/_jsx("small", {
      className: "form-text text-muted text-right",
      children: description
    }), error && /*#__PURE__*/_jsx("div", {
      className: "invalid-feedback",
      children: error
    })]
  });
}
export function Input(_ref2) {
  let {
    type,
    className,
    error: _error,
    id,
    value,
    onChange,
    inputSuffix,
    isValid,
    ...props
  } = _ref2;
  const input = /*#__PURE__*/_jsx("input", {
    type: type,
    className: cx('form-control', className, {
      'is-invalid': !isValid
    }),
    id: id,
    value: value,
    onChange: onChange,
    ...props
  });
  return inputSuffix ? /*#__PURE__*/_jsxs("div", {
    className: "input-suffix__container",
    children: [input, inputSuffix ? /*#__PURE__*/_jsx("span", {
      className: "input-suffix",
      children: inputSuffix
    }) : null]
  }) : input;
}